<template>
  <div class="container">
    <div class="title-container">
      <span>{{ $t('outils.compteur.title') }}</span>
      <ReglePastille cle="outils.definition" />
      <ReglePastille cle="outils.reinitialisationApresEnvoi" />
    </div>
    <CompteursStepBar :step='step'></CompteursStepBar>

    <component :is="getComponent"></component>
  </div>
  <BottomNavigation
    :cancel="cancel"
    :first="step === 0"
    :last="step === 2"
    :next="next"
    :back="back"
    :confirmButtonDisabled="!isValid"
    :confirm="sendMail"
  />
  <InformationCompteurModal @cancel="goHomePage" v-if='modalOpen'/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CompteursStepBar from '@/modules/Outils/components/CompteursStepBar.vue';
import StepOneCompteur from '@/modules/Outils/components/StepOneCompteur.vue';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import { COMPTEUR } from '@/modules/Outils/store/mutation-types';
import { store } from '@/plugins/store';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import InformationCompteurModal from '@/modules/Outils/components/InformationCompteurModal.vue';
import compteurService from '@/modules/Outils/service/CompteurService';
import { FormulaireCompteurDto } from '@/models/FormulaireCompteurDto';
import { Compteur } from '@/modules/Outils/store/state';
import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
  name: 'OutilsPage',
  components: { InformationCompteurModal, ModalCard, Modal, BottomNavigation, StepOneCompteur, CompteursStepBar, ReglePastille },
  data() {
    return {
      modalOpen: false,
    };
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    next() {
      this.$store.commit(COMPTEUR.SET_STEP, this.step + 1);
    },
    back() {
      this.$store.commit(COMPTEUR.SET_STEP, this.step - 1);
    },
    async sendMail() {
      const compteur = this.$store.getters.getForm;

      const lastCompteur : Compteur = compteur.compteurs[compteur.compteurs.length - 1];

      if (lastCompteur.numeroCompteur.trim() === '' && lastCompteur.facture === undefined) {
          this.$store.commit(COMPTEUR.REMOVE_COMPTEUR, lastCompteur);
      }

      const facturesList = compteur.compteurs.map((c: Compteur) => c.facture);
      const compteurdto = new FormulaireCompteurDto(compteur);
      compteurService.sendCounterForm(compteurdto, facturesList)
          .then(() => {
              this.modalOpen = true;
          })
          .catch(async (err: any) => {
              const message = await ErrorManager.processError(err.response);

              this.$store.commit(`errorToaster/${ERROR.SET_ACTIVE}`, true);
              this.$store.commit(`errorToaster/${ERROR.SET_MESSAGE}`, message);
          });
    },

    goHomePage() {
      this.modalOpen = false;
      this.$router.push('/');
      this.$store.commit(COMPTEUR.RESET);
    }
  },
  computed: {
    step: {
      get(): number {
        return this.$store.getters.getCompteurStep;
      },
      set(step: number) {
        this.$store.commit(COMPTEUR.SET_STEP, step);
      },
    },
    isValid() {
        return this.$store.getters.isCompteurFormValid;
    },
    getComponent(){
        return store.getters.getCurrentStep;
    },
  }
});
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px 24px;
  overflow: auto;
  max-height: calc(100vh - 140px);
}
.title-container {
  color: var(--color-principal);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-600);
  margin-bottom: 15px;
}
</style>
